module.exports = __webpack_public_path__ + "img/img22.aa1a9881.png";